<template>
<div id="kt_app_sidebar" class="app-sidebar flex-column">
    <div class="app-sidebar-logo px-6" id="kt_app_sidebar_logo">
        <router-link :to="{name:'home'}" class="router-link-active">
            <img alt="Logo" v-bind:src="'/assets/media/logos/logoUMFTwhite.png'" class="h-45px app-sidebar-logo-default"><!---->
            <img alt="Logo" v-bind:src="'/assets/media/logos/siglaUMFT.png'" class="h-40px app-sidebar-logo-minimize">
        </router-link>
        <div id="kt_app_sidebar_toggle" class="app-sidebar-toggle btn btn-icon btn-shadow btn-sm btn-color-muted btn-active-color-primary body-bg h-30px w-30px position-absolute top-50 start-100 translate-middle rotate" data-kt-toggle="true" data-kt-toggle-state="active" data-kt-toggle-target="body" data-kt-toggle-name="app-sidebar-minimize">
            <span class="svg-icon svg-icon-2 rotate-180">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height="24" width="24">
                    <path xmlns="http://www.w3.org/2000/svg" opacity="0.5" d="M14.2657 11.4343L18.45 7.25C18.8642 6.83579 18.8642 6.16421 18.45 5.75C18.0358 5.33579 17.3642 5.33579 16.95 5.75L11.4071 11.2929C11.0166 11.6834 11.0166 12.3166 11.4071 12.7071L16.95 18.25C17.3642 18.6642 18.0358 18.6642 18.45 18.25C18.8642 17.8358 18.8642 17.1642 18.45 16.75L14.2657 12.5657C13.9533 12.2533 13.9533 11.7467 14.2657 11.4343Z" fill="currentColor"></path>
                    <path xmlns="http://www.w3.org/2000/svg" d="M8.2657 11.4343L12.45 7.25C12.8642 6.83579 12.8642 6.16421 12.45 5.75C12.0358 5.33579 11.3642 5.33579 10.95 5.75L5.40712 11.2929C5.01659 11.6834 5.01659 12.3166 5.40712 12.7071L10.95 18.25C11.3642 18.6642 12.0358 18.6642 12.45 18.25C12.8642 17.8358 12.8642 17.1642 12.45 16.75L8.2657 12.5657C7.95328 12.2533 7.95328 11.7467 8.2657 11.4343Z" fill="currentColor"></path>
                </svg>
            </span>
        </div>
    </div>
    <div class="app-sidebar-menu overflow-hidden flex-column-fluid">
        <div id="kt_app_sidebar_menu_wrapper" class="app-sidebar-wrapper hover-scroll-overlay-y my-5">
            <div class="menu menu-column menu-rounded menu-sub-indention px-3">

                <div class="menu-item">
                    <router-link :to="{name:'admin.Dashboard'}" exact-active-class="active" class="menu-link">
                        <span class="menu-icon">
                            <span class="svg-icon svg-icon-2">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 25" height="25" width="24">
                                    <path xmlns="http://www.w3.org/2000/svg" opacity="0.3" d="M8.9 21L7.19999 22.6999C6.79999 23.0999 6.2 23.0999 5.8 22.6999L4.1 21H8.9ZM4 16.0999L2.3 17.8C1.9 18.2 1.9 18.7999 2.3 19.1999L4 20.9V16.0999ZM19.3 9.1999L15.8 5.6999C15.4 5.2999 14.8 5.2999 14.4 5.6999L9 11.0999V21L19.3 10.6999C19.7 10.2999 19.7 9.5999 19.3 9.1999Z" fill="currentColor"></path>
                                    <path xmlns="http://www.w3.org/2000/svg" d="M21 15V20C21 20.6 20.6 21 20 21H11.8L18.8 14H20C20.6 14 21 14.4 21 15ZM10 21V4C10 3.4 9.6 3 9 3H4C3.4 3 3 3.4 3 4V21C3 21.6 3.4 22 4 22H9C9.6 22 10 21.6 10 21ZM7.5 18.5C7.5 19.1 7.1 19.5 6.5 19.5C5.9 19.5 5.5 19.1 5.5 18.5C5.5 17.9 5.9 17.5 6.5 17.5C7.1 17.5 7.5 17.9 7.5 18.5Z" fill="currentColor"></path>
                                </svg>
                            </span>
                        </span>
                        <span class="menu-title">Dashboard</span>
                    </router-link>
                </div>



                <div class="menu-item menu-accordion" :class="{ show: showConta }">
                    <span class="menu-link" @click="showConta = !showConta">
                        <span class="menu-icon">
                            <span class="svg-icon svg-icon-2">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3 2H10C10.6 2 11 2.4 11 3V10C11 10.6 10.6 11 10 11H3C2.4 11 2 10.6 2 10V3C2 2.4 2.4 2 3 2Z" fill="currentColor"/>
                                    <path opacity="0.3" d="M14 2H21C21.6 2 22 2.4 22 3V10C22 10.6 21.6 11 21 11H14C13.4 11 13 10.6 13 10V3C13 2.4 13.4 2 14 2Z" fill="currentColor"/>
                                    <path opacity="0.3" d="M3 13H10C10.6 13 11 13.4 11 14V21C11 21.6 10.6 22 10 22H3C2.4 22 2 21.6 2 21V14C2 13.4 2.4 13 3 13Z" fill="currentColor"/>
                                    <path opacity="0.3" d="M14 13H21C21.6 13 22 13.4 22 14V21C22 21.6 21.6 22 21 22H14C13.4 22 13 21.6 13 21V14C13 13.4 13.4 13 14 13Z" fill="currentColor"/>
                                </svg>
                            </span>
                        </span>
                        <span class="menu-title">Contabilitate</span>
                        <span class="menu-arrow"></span>
                    </span>
                    <div class="menu-sub menu-sub-accordion" :class="{ show: showConta }">
                        <div class="menu-item" >
                            <router-link :to="{name:'admin.Taxpays'}" exact-active-class="active" class="menu-link">
                                <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
                                <span class="menu-title">Taxe</span>
                            </router-link>
                        </div>
                    </div>
                </div>


                <div class="menu-item">
                    <router-link :to="{name:'admin.Certificates'}" exact-active-class="active" class="menu-link">
                        <span class="menu-icon">
                            <span class="svg-icon svg-icon-2">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 25" height="25" width="24">
                                    <path xmlns="http://www.w3.org/2000/svg" opacity="0.3" d="M8.9 21L7.19999 22.6999C6.79999 23.0999 6.2 23.0999 5.8 22.6999L4.1 21H8.9ZM4 16.0999L2.3 17.8C1.9 18.2 1.9 18.7999 2.3 19.1999L4 20.9V16.0999ZM19.3 9.1999L15.8 5.6999C15.4 5.2999 14.8 5.2999 14.4 5.6999L9 11.0999V21L19.3 10.6999C19.7 10.2999 19.7 9.5999 19.3 9.1999Z" fill="currentColor"></path>
                                    <path xmlns="http://www.w3.org/2000/svg" d="M21 15V20C21 20.6 20.6 21 20 21H11.8L18.8 14H20C20.6 14 21 14.4 21 15ZM10 21V4C10 3.4 9.6 3 9 3H4C3.4 3 3 3.4 3 4V21C3 21.6 3.4 22 4 22H9C9.6 22 10 21.6 10 21ZM7.5 18.5C7.5 19.1 7.1 19.5 6.5 19.5C5.9 19.5 5.5 19.1 5.5 18.5C5.5 17.9 5.9 17.5 6.5 17.5C7.1 17.5 7.5 17.9 7.5 18.5Z" fill="currentColor"></path>
                                </svg>
                            </span>
                        </span>
                        <span class="menu-title">Adeverinte</span>
                    </router-link>
                </div>

                <div class="menu-item menu-accordion" :class="{ show: showSettings }">
                    <span class="menu-link" @click="showSettings = !showSettings">
                        <span class="menu-icon">
                            <span class="svg-icon svg-icon-2">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3 2H10C10.6 2 11 2.4 11 3V10C11 10.6 10.6 11 10 11H3C2.4 11 2 10.6 2 10V3C2 2.4 2.4 2 3 2Z" fill="currentColor"/>
                                    <path opacity="0.3" d="M14 2H21C21.6 2 22 2.4 22 3V10C22 10.6 21.6 11 21 11H14C13.4 11 13 10.6 13 10V3C13 2.4 13.4 2 14 2Z" fill="currentColor"/>
                                    <path opacity="0.3" d="M3 13H10C10.6 13 11 13.4 11 14V21C11 21.6 10.6 22 10 22H3C2.4 22 2 21.6 2 21V14C2 13.4 2.4 13 3 13Z" fill="currentColor"/>
                                    <path opacity="0.3" d="M14 13H21C21.6 13 22 13.4 22 14V21C22 21.6 21.6 22 21 22H14C13.4 22 13 21.6 13 21V14C13 13.4 13.4 13 14 13Z" fill="currentColor"/>
                                </svg>
                            </span>
                        </span>
                        <span class="menu-title">Data</span>
                        <span class="menu-arrow"></span>
                    </span>
                    <div class="menu-sub menu-sub-accordion" :class="{ show: showSettings }">
                        <div class="menu-item" >
                            <router-link :to="{name:'admin.Users'}" exact-active-class="active" class="menu-link">
                                <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
                                <span class="menu-title">Utilizatori</span>
                            </router-link>
                        </div>
                        <div class="menu-item" >
                            <router-link :to="{name:'admin.Usersverify'}" exact-active-class="active" class="menu-link">
                                <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
                                <span class="menu-title">Verificare utilizatori</span>
                            </router-link>
                        </div>
                        <div class="menu-item" >
                            <router-link :to="{name:'admin.ImportEmsys'}" exact-active-class="active" class="menu-link">
                                <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
                                <span class="menu-title">Import Emsys</span>
                            </router-link>
                        </div>
                        <div class="menu-item" v-if="can('sesiunitaxe.view | sesiunitaxe.create | sesiunitaxe.edit | sesiunitaxe.delete')">
                            <router-link :to="{name:'admin.SesiuneTaxes'}" exact-active-class="active" class="menu-link">
                                <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
                                <span class="menu-title">Sesiuni taxe</span>
                            </router-link>
                        </div>
                        <div class="menu-item"  v-if="can('cstudiis.view | cstudiis.create | cstudiis.edit | cstudiis.delete')">
                            <router-link :to="{name:'admin.Cstudii'}" exact-active-class="active" class="menu-link">
                                <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
                                <span class="menu-title">Ciclu srtudii</span>
                            </router-link>
                        </div>
                        <div class="menu-item"  v-if="can('facultatiumft.view | facultatiumft.create | facultatiumft.edit | facultatiumft.delete')">
                            <router-link :to="{name:'admin.Facultatiumfts'}" exact-active-class="active" class="menu-link">
                                <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
                                <span class="menu-title">Facultati</span>
                            </router-link>
                        </div>
                        <div class="menu-item"  v-if="can('specializariumft.view | specializariumft.create | specializariumft.edit | specializariumft.delete')">
                            <router-link :to="{name:'admin.Specializariumfts'}" exact-active-class="active" class="menu-link">
                                <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
                                <span class="menu-title">Specializari</span>
                            </router-link>
                        </div>


                        <div class="menu-item" >
                            <router-link :to="{name:'admin.GlobalVariables'}" exact-active-class="active" class="menu-link">
                                <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
                                <span class="menu-title">Setari globale</span>
                            </router-link>
                        </div>
                    </div>
                </div>



            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "DSidebar.vue",
    components: {

    },
    computed : {
        isLoggedIn : function(){ return this.$store.getters['auth/isAuthenticated'] },
        isAdmin : function(){ return this.$store.getters['auth/isAdmin'] },
        user : function(){ return this.$store.getters['auth/getFullUser'] },
    },
    watch: {
        $route: {
            immediate: true,
            handler(to, from) {
                switch(this.$route.name) {
                    case 'admin.Confirms':
                        this.showConta = true;
                        break;
                    case 'admin.Users':
                    case 'admin.User':
                    case 'admin.Usersverify':
                    case 'admin.ImportEmsys':
                    case 'admin.Cstudii':
                    case 'admin.Cstudiu':
                    case 'admin.Facultatiumfts':
                    case 'admin.Facultatiumft':
                    case 'admin.Specializariumfts':
                    case 'admin.Specializariumft':
                    case 'admin.Sesiunetaxes':
                    case 'admin.Sesiunetaxe':

                    case 'admin.GlobalVariables':
                        this.showSettings = true;
                        break;
                }

            }
        },
    },
    data () {
        return {
            showConta: false,
            showSettings: false,
        }
    },
}
</script>

<style scoped>

</style>
